import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const CloseFilled = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="9 6 78 78">
      <defs>
        <filter id="Ellipse_463" x="0" y="0" width="96" height="96" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood floodOpacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <g id="Groupe_5547" data-name="Groupe 5547" transform="translate(-832 -596)">
        <g transform="matrix(1, 0, 0, 1, 832, 596)" filter="url(#Ellipse_463)">
          <circle id="Ellipse_463-2" data-name="Ellipse 463" cx="39" cy="39" r="39" transform="translate(9 6)" fill="#ed6a5a"/>
        </g>
        <g id="Groupe_5545" data-name="Groupe 5545" transform="translate(1 40)">
          <line id="Ligne_77" data-name="Ligne 77" x2="29" y2="29" transform="translate(864.5 586.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="4"/>
          <line id="Ligne_78" data-name="Ligne 78" x1="29" y2="29" transform="translate(864.5 586.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="4"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default CloseFilled;